<template>
  <div>
    <a-modal
      :visible="true"
      title="排序"
      @cancel="handleCancel"
      :width="800"
      @ok="handleOk"
    >
      <div>
        <table class="itxst" v-if="list.length > 0">
          <thead>
            <tr>
              <th width="50">序号</th>
              <th width="250">企业名称</th>
              <th width="250">专利数</th>
              <th width="250">最后更新日期</th>
            </tr>
          </thead>
          <draggable element="tbody"  v-model="list" >
            <tr v-for="(item, index) in list" :key="item.key">
              <td class="move">{{ index + 1 }}</td>
              <td>{{ item.enpName || '' }}</td>
              <td>{{ item.patentCount || 0 }}</td>
              <td>{{ item.endUpdateTime || '' }}</td>
            </tr>
          </draggable>
        </table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { competitorLibrarySort } from '@/api/superViseInfos'

export default {
  props: {
    tableValue: Array,
  },
  data() {
    return {
      visible: false,
      drag: false,
      list: [],
      sortList: [],
    }
  },
  watch: {
    tableValue: {
      handler(val) {
        if (val) {
          this.list = JSON.parse(JSON.stringify(val))
        }
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    draggable,
  },
  methods: {
    handleOk() {
      const params = []
      this.list.forEach((item, index) => {
        const obj = {}
        obj.id = item.id
        obj.sort = index + 1
        params.push(obj)
      })
      competitorLibrarySort(params).then((res) => {
        if (res.code === 200) {
          this.$message.success('排序成功!')
          this.$emit('updateList')
        }
      })
    },
    handleCancel() {
      this.$emit('cancelVisible', false)
    },
    onStart() {
      this.drag = true
    },
    onEnd() {
      this.drag = false
    },
  },
}
</script>

<style scoped>
table.itxst {
  color: #333333;
  border: rgb(235, 232, 232) solid 1px;
  border-collapse: collapse;
}

table.itxst th {
  border: rgb(235, 232, 232) solid 1px;
  padding: 8px;
  background-color: #ebe8e8;
}

table.itxst td {
  border: rgb(235, 232, 232) solid 1px;
  padding: 8px;
  background-color: #ffffff;
}

table.itxst tr {
  cursor: pointer;
}

table.itxst td.move:hover {
  cursor: move;
}
</style>
